import React from "react";

import { ButtonWithRouter, ButtonWithIcon } from "./ButtonWithIcon";
import { LexWorkplaceCheckIcon, LexWorkplaceXIcon } from "./LexWorkplaceIcons";

/**
 * A two-column form wrapper using flexbox with row-based layout.
 *
 * Props:
 * - rows: Array of arrays, where each inner array contains the fields for that row.
 *         Fields in the same row will be equally sized and stay aligned.
 *         Example: [[<Field1 />, <Field2 />], [<Field3 />], [<A />, <B />, <C />]]
 * - headingText: The heading text for the form
 * - iconComponent: Optional icon to display next to the heading
 * - rightHeading: Optional content for the right side of the heading
 * - canSubmit: Boolean indicating if the form can be submitted
 * - submitDisabledHoverText: Text to show when hovering over disabled submit button
 * - submit: Function to call when submitting the form
 * - submitButtonText: Text for the submit button
 * - cancelButtonText: Text for the cancel button (defaults to "Cancel")
 * - defaultGoBackLocation: Location to navigate to when canceling
 * - rowGap: Gap between rows (defaults to 0)
 * - columnGap: Gap between columns in a row (defaults to 50)
 */
function FlexFormWrapper(props) {
	const { rowGap = 0, columnGap = 50, section2 } = props;

	const buttonElements = (
		<div
			style={{
				display: "flex",
				justifyContent: "flex-end",
			}}
		>
			<ButtonWithRouter
				type="go-back"
				defaultGoBackLocation={props.defaultGoBackLocation}
				buttonText={props.cancelButtonText || "Cancel"}
				iconComponent={<LexWorkplaceXIcon />}
				style={{ marginRight: 8 }}
			/>
			<ButtonWithIcon
				handler={() => {
					props.canSubmit && props.submit();
				}}
				disabledHoverText={props.submitDisabledHoverText}
				buttonText={props.submitButtonText}
				className="blue"
				disabled={!props.canSubmit}
				iconComponent={<LexWorkplaceCheckIcon />}
			/>
		</div>
	);

	return (
		<div className="noDefaultMargin" style={{ margin: "0 30px 30px 30px" }}>
			<div
				style={{
					height: 64,
					lineHeight: "64px",
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					gap: 8,
				}}
			>
				<div style={{ minWidth: "fit-content" }}>
					{props.iconComponent ? props.iconComponent : null}
					<span
						style={{
							fontFamily: "MainFont-SemiBold",
							fontSize: 16,
							marginLeft: 8,
						}}
					>
						{props.headingText}
					</span>
				</div>
				{props.rightHeading ? <div>{props.rightHeading}</div> : null}
			</div>
			<div
				style={{
					backgroundColor: "var(--lw-light-grey-a)",
					padding: 30,
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: rowGap,
					}}
				>
					{props.rows.map((row, rowIndex) => (
						<div
							key={rowIndex}
							style={{
								display: "flex",
								gap: columnGap,
							}}
						>
							{row.map((field, fieldIndex) => (
								<div
									key={fieldIndex}
									style={{
										flex: 1,
										minWidth: 0,
										maxWidth: "45vw",
									}}
								>
									{field}
								</div>
							))}
						</div>
					))}
				</div>
				{!section2 ? buttonElements : null}
			</div>
			{section2 ? <div>{section2}</div> : null}
			{section2 ? buttonElements : null}
		</div>
	);
}

export default FlexFormWrapper;
